import { render } from "./NonRegulatedSubsComponent.vue?vue&type=template&id=75636c4d&lang=true"
import script from "./NonRegulatedSubsComponent.vue?vue&type=script&lang=js"
export * from "./NonRegulatedSubsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__